import { TActiveColorKey, TContrastLevel } from '~theme/typings'

export type TButtonVariantProps =
  | {
      /**
       * solid = filled background, provide some `bgColor`
       */
      variant?: 'solid'
      /**
       * color of the button (solid variant)
       */
      bgColor: TActiveColorKey
      borderContrast?: undefined
    }
  | {
      /**
       * outline = transparent with border,
       * you can set the `borderContrast`
       */
      variant?: 'outline'
      /**
       * used just for hover state
       */
      bgColor?: TActiveColorKey
      /**
       * contrast level of the button border, works only with the `outline` variant
       */
      borderContrast?: TContrastLevel
    }
  | {
      /**
       * ghost = transparent without border (can still have shadow though),
       */
      variant?: 'ghost'
      /**
       * used just for hover state
       */
      bgColor?: TActiveColorKey
      borderContrast?: undefined
    }

type TBuildButtonVariantOptions = {
  [key in keyof TButtonVariantProps]: TButtonVariantProps[key]
}

/**
 * helper function that can be used to create a valid button variant prop set
 */
export const buildButtonVariantProps = ({
  bgColor,
  variant,
  borderContrast,
}: TBuildButtonVariantOptions): TButtonVariantProps => {
  if (variant === `outline`) {
    return {
      variant,
      bgColor,
      borderContrast,
    }
  }

  if (variant === `ghost`) {
    return {
      variant,
      bgColor,
    }
  }

  // variant === `solid` || variant === undefined
  return {
    variant,
    // this "default" value is not here to be abused just to fulfill the type requirements
    // we might want to add some console log in such case but still, throwing an error would be an overkill
    bgColor: bgColor ?? `primary`,
  }
}
